export default function ArrowTiltRightIcon({ className = '', stroke = '#2571CF' }) {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.829956 11.5L10.83 1.5M10.83 1.5H3.32996M10.83 1.5V9"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
